/*
 * Copyright (c) 2023-2024 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { useEffect } from "react";
import { getFileExtension } from "../util/File";

const getMediaType = (extension) => {
  switch (extension) {
    case "jpg":
    case "jpeg":
    case "png":
    case "gif":
      return "image";
    case "mp3":
      return "audio";
    case "mp4":
    case "webm":
    case "ogg":
      return "video";
    default:
      return null;
  }
};

const Media = ({
  src,
  alt = "Unable to load media",
  style,
  onLoad,
  onError,
  children,
}) => {
  const extension = getFileExtension(src);
  const type = getMediaType(extension);

  useEffect(() => {
    if (src != null && src !== "" && type == null) {
      onError?.();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [src]);

  const mediaProps = {
    src: src,
    alt: alt,
  };

  const containerProps = {
    style: style,
    onError: onError,
  };

  const onLoadedData = () => {
    document.getElementById("media-video").play();
    onLoad?.();
  };

  switch (type) {
    case "image":
      return (
        <img alt="" onLoad={onLoad} {...mediaProps} {...containerProps} />
      );
    case "audio":
      return (
        <audio controls>
          <source onLoad={onLoad} type={`audio/${extension}`} {...mediaProps} />
        </audio>
      )
    // NOTE: Video formats (.mp4, .webm, .ogg) all inconsistent on mobile
    case "video":
      return (
        <video id="media-video" onLoadedData={onLoadedData} autoPlay muted playsInline loop {...containerProps} >
          <source type={`video/${extension}`} {...mediaProps} />
        </video>
      );
    default:
      return children;
  }
};

export default Media;
